declare namespace $ {

	type $mol_theme_auto__theme_bog_vmap_app_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['theme_name'] >
		,
		ReturnType< $mol_theme_auto['theme'] >
	>
	type $mol_view__attr_bog_vmap_app_2 = $mol_type_enforce<
		({ 
			'inert': ReturnType< $bog_vmap_app['doc_pending'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_vmap_app_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['main'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_icon__Icon_bog_vmap_app_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['Left_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__hint_bog_vmap_app_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_bog_vmap_app_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['left_showed'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_bog_vmap_app_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['Tool_select_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__hint_bog_vmap_app_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_bog_vmap_app_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['tool_select'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_bog_vmap_app_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['Tool_board_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__hint_bog_vmap_app_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_bog_vmap_app_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['tool_board'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__enabled_bog_vmap_app_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['editable'] >
		,
		ReturnType< $mol_check_icon['enabled'] >
	>
	type $mol_check_icon__Icon_bog_vmap_app_14 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['Tool_text_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__hint_bog_vmap_app_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_bog_vmap_app_16 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['tool_text'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__enabled_bog_vmap_app_17 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['text_enabled'] >
		,
		ReturnType< $mol_check_icon['enabled'] >
	>
	type $mol_check_icon__Icon_bog_vmap_app_18 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['Tool_hand_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__hint_bog_vmap_app_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_bog_vmap_app_20 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['tool_hand'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_button_minor__title_bog_vmap_app_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_22 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['delete_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_23 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['delete_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_vmap_app_24 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_bar__attr_bog_vmap_app_25 = $mol_type_enforce<
		({ 
			'inert': ReturnType< $bog_vmap_app['doc_pending'] >,
		})  & ReturnType< $mol_bar['attr'] >
		,
		ReturnType< $mol_bar['attr'] >
	>
	type $mol_bar__sub_bog_vmap_app_26 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['instruments'] >
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_string__attr_bog_vmap_app_27 = $mol_type_enforce<
		({ 
			'inert': ReturnType< $bog_vmap_app['doc_pending'] >,
		})  & ReturnType< $mol_string['attr'] >
		,
		ReturnType< $mol_string['attr'] >
	>
	type $mol_string__enabled_bog_vmap_app_28 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['editable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__hint_bog_vmap_app_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_vmap_app_30 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['root_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_vmap_app_31 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['root_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_bog_vmap_app_32 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $bog_vmap_app['root_submit'] > ): ReturnType< $bog_vmap_app['root_submit'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_button_minor__title_bog_vmap_app_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_35 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['zoom_out'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_vmap_app_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_38 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['camera_reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_vmap_app_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_41 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['zoom_in'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_check_icon__Icon_bog_vmap_app_42 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['History_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__hint_bog_vmap_app_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_bog_vmap_app_44 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['history_showed'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $bog_vmap_app_publish__attr_bog_vmap_app_45 = $mol_type_enforce<
		({ 
			'inert': ReturnType< $bog_vmap_app['doc_pending'] >,
		})  & ReturnType< $bog_vmap_app_publish['attr'] >
		,
		ReturnType< $bog_vmap_app_publish['attr'] >
	>
	type $bog_vmap_app_publish__foreign_bog_vmap_app_46 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_readonly'] >
		,
		ReturnType< $bog_vmap_app_publish['foreign'] >
	>
	type $bog_vmap_app_publish__part_bog_vmap_app_47 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['publish_part'] >
		,
		ReturnType< $bog_vmap_app_publish['part'] >
	>
	type $bog_vmap_app_publish__source_bog_vmap_app_48 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_source'] >
		,
		ReturnType< $bog_vmap_app_publish['source'] >
	>
	type $bog_vmap_app_publish__js_bog_vmap_app_49 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_js'] >
		,
		ReturnType< $bog_vmap_app_publish['js'] >
	>
	type $bog_vmap_app_publish__css_bog_vmap_app_50 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['root_css'] >
		,
		ReturnType< $bog_vmap_app_publish['css'] >
	>
	type $bog_vmap_app_publish__doc_bog_vmap_app_51 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_src'] >
		,
		ReturnType< $bog_vmap_app_publish['doc'] >
	>
	type $bog_vmap_app_publish__classes_bog_vmap_app_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_vmap_app_publish['classes'] >
	>
	type $mol_button_download__title_bog_vmap_app_53 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['export_title'] >
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__hint_bog_vmap_app_54 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['export_hint'] >
		,
		ReturnType< $mol_button_download['hint'] >
	>
	type $mol_button_download__enabled_bog_vmap_app_55 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['export_ready'] >
		,
		ReturnType< $mol_button_download['enabled'] >
	>
	type $mol_button_download__blob_bog_vmap_app_56 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['export_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__file_name_bog_vmap_app_57 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['export_file'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_lights_toggle__lights_bog_vmap_app_58 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['lights'] >
		,
		ReturnType< $mol_lights_toggle['lights'] >
	>
	type $mol_check_icon__Icon_bog_vmap_app_59 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['Right_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__hint_bog_vmap_app_60 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_bog_vmap_app_61 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['right_showed'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_switch__value_bog_vmap_app_62 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['left_tab'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_vmap_app_63 = $mol_type_enforce<
		({ 
			'layers': string,
			'assets': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type __bog_vmap_app_64 = $mol_type_enforce<
		Parameters< $bog_vmap_app['tool_select'] >[0]
		,
		Parameters< ReturnType< $bog_vmap_app['Pane'] >['tool_select'] >[0]
	>
	type __bog_vmap_app_65 = $mol_type_enforce<
		Parameters< $bog_vmap_app['tool_board'] >[0]
		,
		Parameters< ReturnType< $bog_vmap_app['Pane'] >['tool_board'] >[0]
	>
	type __bog_vmap_app_66 = $mol_type_enforce<
		Parameters< $bog_vmap_app['tool_text'] >[0]
		,
		Parameters< ReturnType< $bog_vmap_app['Pane'] >['tool_text'] >[0]
	>
	type __bog_vmap_app_67 = $mol_type_enforce<
		Parameters< $bog_vmap_app['tool_hand'] >[0]
		,
		Parameters< ReturnType< $bog_vmap_app['Pane'] >['tool_hand'] >[0]
	>
	type __bog_vmap_app_68 = $mol_type_enforce<
		Parameters< $bog_vmap_app['node_show'] >[0]
		,
		Parameters< ReturnType< $bog_vmap_app['Pane'] >['node_show'] >[0]
	>
	type $bog_vmap_app_pane__editable_bog_vmap_app_69 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['editable'] >
		,
		ReturnType< $bog_vmap_app_pane['editable'] >
	>
	type $bog_vmap_app_pane__scene_bundle_bog_vmap_app_70 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['scene_bundle'] >
		,
		ReturnType< $bog_vmap_app_pane['scene_bundle'] >
	>
	type $bog_vmap_app_pane__pack_uri_bog_vmap_app_71 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['pack_script'] >
		,
		ReturnType< $bog_vmap_app_pane['pack_uri'] >
	>
	type $bog_vmap_app_pane__theme_bog_vmap_app_72 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['scene_theme'] >
		,
		ReturnType< $bog_vmap_app_pane['theme'] >
	>
	type $bog_vmap_app_pane__doc_src_bog_vmap_app_73 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_src'] >
		,
		ReturnType< $bog_vmap_app_pane['doc_src'] >
	>
	type $bog_vmap_app_pane__doc_css_bog_vmap_app_74 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_css'] >
		,
		ReturnType< $bog_vmap_app_pane['doc_css'] >
	>
	type $bog_vmap_app_pane__spots_bog_vmap_app_75 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['spots'] >
		,
		ReturnType< $bog_vmap_app_pane['spots'] >
	>
	type $bog_vmap_app_pane__guides_bog_vmap_app_76 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['guides'] >
		,
		ReturnType< $bog_vmap_app_pane['guides'] >
	>
	type $bog_vmap_app_pane__picked_bog_vmap_app_77 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['picked'] >
		,
		ReturnType< $bog_vmap_app_pane['picked'] >
	>
	type $bog_vmap_app_pane__inner_bog_vmap_app_78 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['inner'] >
		,
		ReturnType< $bog_vmap_app_pane['inner'] >
	>
	type $bog_vmap_app_pane__entered_bog_vmap_app_79 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['entered'] >
		,
		ReturnType< $bog_vmap_app_pane['entered'] >
	>
	type $bog_vmap_app_pane__doc_js_bog_vmap_app_80 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_js'] >
		,
		ReturnType< $bog_vmap_app_pane['doc_js'] >
	>
	type $bog_vmap_app_pane__doc_root_bog_vmap_app_81 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_root'] >
		,
		ReturnType< $bog_vmap_app_pane['doc_root'] >
	>
	type $bog_vmap_app_pane__libs_bog_vmap_app_82 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['libs'] >
		,
		ReturnType< $bog_vmap_app_pane['libs'] >
	>
	type $bog_vmap_app_pane__carrying_bog_vmap_app_83 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['carrying'] >
		,
		ReturnType< $bog_vmap_app_pane['carrying'] >
	>
	type $bog_vmap_app_pane__wires_bog_vmap_app_84 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_wires'] >
		,
		ReturnType< $bog_vmap_app_pane['wires'] >
	>
	type $bog_vmap_app_pane__part_ports_bog_vmap_app_85 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['part_ports'] >
		,
		ReturnType< $bog_vmap_app_pane['part_ports'] >
	>
	type $bog_vmap_app_pane__part_overs_bog_vmap_app_86 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['part_overs'] >
		,
		ReturnType< $bog_vmap_app_pane['part_overs'] >
	>
	type $bog_vmap_app_pane__link_add_bog_vmap_app_87 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['link_add'] >
		,
		ReturnType< $bog_vmap_app_pane['link_add'] >
	>
	type $bog_vmap_app_pane__link_drop_bog_vmap_app_88 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['link_drop'] >
		,
		ReturnType< $bog_vmap_app_pane['link_drop'] >
	>
	type $bog_vmap_app_pane__containers_bog_vmap_app_89 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_containers'] >
		,
		ReturnType< $bog_vmap_app_pane['containers'] >
	>
	type $bog_vmap_app_pane__doc_names_bog_vmap_app_90 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_names'] >
		,
		ReturnType< $bog_vmap_app_pane['doc_names'] >
	>
	type $bog_vmap_app_pane__doc_paths_bog_vmap_app_91 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_paths'] >
		,
		ReturnType< $bog_vmap_app_pane['doc_paths'] >
	>
	type $bog_vmap_app_pane__doc_key_bog_vmap_app_92 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_key'] >
		,
		ReturnType< $bog_vmap_app_pane['doc_key'] >
	>
	type $bog_vmap_app_pane__node_title_bog_vmap_app_93 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_title'] >
		,
		ReturnType< $bog_vmap_app_pane['node_title'] >
	>
	type $bog_vmap_app_pane__axis_bog_vmap_app_94 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_axis'] >
		,
		ReturnType< $bog_vmap_app_pane['axis'] >
	>
	type $bog_vmap_app_pane__tree_move_bog_vmap_app_95 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['tree_move'] >
		,
		ReturnType< $bog_vmap_app_pane['tree_move'] >
	>
	type $bog_vmap_app_pane__carry_drop_bog_vmap_app_96 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['carry_drop'] >
		,
		ReturnType< $bog_vmap_app_pane['carry_drop'] >
	>
	type $bog_vmap_app_pane__files_drop_bog_vmap_app_97 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['files_drop'] >
		,
		ReturnType< $bog_vmap_app_pane['files_drop'] >
	>
	type $bog_vmap_app_pane__node_delete_bog_vmap_app_98 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_delete'] >
		,
		ReturnType< $bog_vmap_app_pane['node_delete'] >
	>
	type $bog_vmap_app_pane__node_copy_bog_vmap_app_99 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_copy'] >
		,
		ReturnType< $bog_vmap_app_pane['node_copy'] >
	>
	type $bog_vmap_app_pane__node_wrap_bog_vmap_app_100 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_wrap'] >
		,
		ReturnType< $bog_vmap_app_pane['node_wrap'] >
	>
	type $bog_vmap_app_pane__node_group_bog_vmap_app_101 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_group'] >
		,
		ReturnType< $bog_vmap_app_pane['node_group'] >
	>
	type $bog_vmap_app_pane__node_ungroup_bog_vmap_app_102 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_ungroup'] >
		,
		ReturnType< $bog_vmap_app_pane['node_ungroup'] >
	>
	type $bog_vmap_app_pane__ungroup_enabled_bog_vmap_app_103 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['ungroup_enabled'] >
		,
		ReturnType< $bog_vmap_app_pane['ungroup_enabled'] >
	>
	type $bog_vmap_app_pane__node_reset_all_bog_vmap_app_104 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_reset_all'] >
		,
		ReturnType< $bog_vmap_app_pane['node_reset_all'] >
	>
	type $bog_vmap_app_pane__reset_enabled_bog_vmap_app_105 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['reset_enabled'] >
		,
		ReturnType< $bog_vmap_app_pane['reset_enabled'] >
	>
	type $bog_vmap_app_pane__node_clone_bog_vmap_app_106 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_clone'] >
		,
		ReturnType< $bog_vmap_app_pane['node_clone'] >
	>
	type $bog_vmap_app_pane__board_draw_bog_vmap_app_107 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['board_draw'] >
		,
		ReturnType< $bog_vmap_app_pane['board_draw'] >
	>
	type $bog_vmap_app_pane__text_draw_bog_vmap_app_108 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['text_draw'] >
		,
		ReturnType< $bog_vmap_app_pane['text_draw'] >
	>
	type $bog_vmap_app_pane__text_enabled_bog_vmap_app_109 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['text_enabled'] >
		,
		ReturnType< $bog_vmap_app_pane['text_enabled'] >
	>
	type $bog_vmap_app_pane__node_resize_bog_vmap_app_110 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_resize'] >
		,
		ReturnType< $bog_vmap_app_pane['node_resize'] >
	>
	type $bog_vmap_app_pane__node_text_bog_vmap_app_111 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_text'] >
		,
		ReturnType< $bog_vmap_app_pane['node_text'] >
	>
	type $bog_vmap_app_pane__node_text_kind_bog_vmap_app_112 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_text_kind'] >
		,
		ReturnType< $bog_vmap_app_pane['node_text_kind'] >
	>
	type $bog_vmap_app_pane__node_text_write_bog_vmap_app_113 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_text_write'] >
		,
		ReturnType< $bog_vmap_app_pane['node_text_write'] >
	>
	type $mol_paragraph__title_bog_vmap_app_114 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['idle_note'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_vmap_app_115 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_bog_vmap_app_116 = $mol_type_enforce<
		({ 
			'width': ReturnType< $bog_vmap_app['right_width'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_vmap_app_117 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['right_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_bog_vmap_app_118 = $mol_type_enforce<
		({ 
			'bog_vmap_app_right_grip': string,
			'title': string,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_bog_vmap_app_119 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_vmap_app['grip_press'] > ): ReturnType< $bog_vmap_app['grip_press'] >,
			dblclick( next?: ReturnType< $bog_vmap_app['grip_reset'] > ): ReturnType< $bog_vmap_app['grip_reset'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_switch__value_bog_vmap_app_120 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['right_tab'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_vmap_app_121 = $mol_type_enforce<
		({ 
			'design': string,
			'code': string,
			'history': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $bog_vmap_app_align__act_bog_vmap_app_122 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['align_act'] >
		,
		ReturnType< $bog_vmap_app_align['act'] >
	>
	type $bog_vmap_app_align__button_enabled_bog_vmap_app_123 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['align_enabled'] >
		,
		ReturnType< $bog_vmap_app_align['button_enabled'] >
	>
	type $bog_vmap_app_align__note_bog_vmap_app_124 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['align_note'] >
		,
		ReturnType< $bog_vmap_app_align['note'] >
	>
	type $mol_page__title_bog_vmap_app_125 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__sub_bog_vmap_app_126 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['sub'] >
	>
	type $mol_page__body_bog_vmap_app_127 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_bog_vmap_app_128 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['canvas_foot'] >
		,
		ReturnType< $mol_page['foot'] >
	>
	type $bog_vmap_app_scenes__store_bog_vmap_app_129 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['store'] >
		,
		ReturnType< $bog_vmap_app_scenes['store'] >
	>
	type $bog_vmap_app_scenes__face_brief_bog_vmap_app_130 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['face_brief'] >
		,
		ReturnType< $bog_vmap_app_scenes['face_brief'] >
	>
	type $bog_vmap_app_scenes__face_note_bog_vmap_app_131 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['face_note'] >
		,
		ReturnType< $bog_vmap_app_scenes['face_note'] >
	>
	type $bog_vmap_app_scenes__face_who_bog_vmap_app_132 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['face_who'] >
		,
		ReturnType< $bog_vmap_app_scenes['face_who'] >
	>
	type $bog_vmap_app_scenes__face_blob_bog_vmap_app_133 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['face_blob'] >
		,
		ReturnType< $bog_vmap_app_scenes['face_blob'] >
	>
	type $bog_vmap_app_scenes__face_file_bog_vmap_app_134 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['face_file'] >
		,
		ReturnType< $bog_vmap_app_scenes['face_file'] >
	>
	type $bog_vmap_app_scenes__face_draft_bog_vmap_app_135 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['face_draft'] >
		,
		ReturnType< $bog_vmap_app_scenes['face_draft'] >
	>
	type $bog_vmap_app_scenes__face_take_bog_vmap_app_136 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['face_take'] >
		,
		ReturnType< $bog_vmap_app_scenes['face_take'] >
	>
	type $bog_vmap_app_scenes__face_status_bog_vmap_app_137 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['face_status'] >
		,
		ReturnType< $bog_vmap_app_scenes['face_status'] >
	>
	type $bog_vmap_app_layers__source_bog_vmap_app_138 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_src'] >
		,
		ReturnType< $bog_vmap_app_layers['source'] >
	>
	type $bog_vmap_app_layers__root_bog_vmap_app_139 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_root'] >
		,
		ReturnType< $bog_vmap_app_layers['root'] >
	>
	type $bog_vmap_app_layers__doc_key_bog_vmap_app_140 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['doc_key'] >
		,
		ReturnType< $bog_vmap_app_layers['doc_key'] >
	>
	type $bog_vmap_app_layers__picked_bog_vmap_app_141 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['picked'] >
		,
		ReturnType< $bog_vmap_app_layers['picked'] >
	>
	type $bog_vmap_app_layers__inner_bog_vmap_app_142 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['inner'] >
		,
		ReturnType< $bog_vmap_app_layers['inner'] >
	>
	type $bog_vmap_app_layers__inner_kids_bog_vmap_app_143 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['inner_kids'] >
		,
		ReturnType< $bog_vmap_app_layers['inner_kids'] >
	>
	type $bog_vmap_app_layers__inner_class_bog_vmap_app_144 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['inner_class'] >
		,
		ReturnType< $bog_vmap_app_layers['inner_class'] >
	>
	type $bog_vmap_app_layers__inner_alien_bog_vmap_app_145 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['inner_alien'] >
		,
		ReturnType< $bog_vmap_app_layers['inner_alien'] >
	>
	type $bog_vmap_app_layers__node_title_bog_vmap_app_146 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_title'] >
		,
		ReturnType< $bog_vmap_app_layers['node_title'] >
	>
	type $bog_vmap_app_layers__node_title_note_bog_vmap_app_147 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_title_note'] >
		,
		ReturnType< $bog_vmap_app_layers['node_title_note'] >
	>
	type $bog_vmap_app_layers__tree_move_bog_vmap_app_148 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['tree_move'] >
		,
		ReturnType< $bog_vmap_app_layers['tree_move'] >
	>
	type $bog_vmap_app_layers__node_show_bog_vmap_app_149 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_show'] >
		,
		ReturnType< $bog_vmap_app_layers['node_show'] >
	>
	type $bog_vmap_app_layers__editable_bog_vmap_app_150 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['editable'] >
		,
		ReturnType< $bog_vmap_app_layers['editable'] >
	>
	type $bog_vmap_app_shelf__Title_bog_vmap_app_151 = $mol_type_enforce<
		any
		,
		ReturnType< $bog_vmap_app_shelf['Title'] >
	>
	type $bog_vmap_app_shelf__editable_bog_vmap_app_152 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['editable'] >
		,
		ReturnType< $bog_vmap_app_shelf['editable'] >
	>
	type $bog_vmap_app_shelf__links_bog_vmap_app_153 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['links'] >
		,
		ReturnType< $bog_vmap_app_shelf['links'] >
	>
	type $bog_vmap_app_shelf__pack_link_bog_vmap_app_154 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['pack_link'] >
		,
		ReturnType< $bog_vmap_app_shelf['pack_link'] >
	>
	type $bog_vmap_app_shelf__land_classes_bog_vmap_app_155 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['lib_classes'] >
		,
		ReturnType< $bog_vmap_app_shelf['land_classes'] >
	>
	type $bog_vmap_app_shelf__class_list_bog_vmap_app_156 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['lib_class_list'] >
		,
		ReturnType< $bog_vmap_app_shelf['class_list'] >
	>
	type $bog_vmap_app_shelf__place_bog_vmap_app_157 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['shelf_place'] >
		,
		ReturnType< $bog_vmap_app_shelf['place'] >
	>
	type $bog_vmap_app_inspect__source_bog_vmap_app_158 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_source'] >
		,
		ReturnType< $bog_vmap_app_inspect['source'] >
	>
	type $bog_vmap_app_inspect__peers_bog_vmap_app_159 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_peers'] >
		,
		ReturnType< $bog_vmap_app_inspect['peers'] >
	>
	type $bog_vmap_app_inspect__pack_bog_vmap_app_160 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['pack_link'] >
		,
		ReturnType< $bog_vmap_app_inspect['pack'] >
	>
	type $bog_vmap_app_inspect__class_title_bog_vmap_app_161 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_title'] >
		,
		ReturnType< $bog_vmap_app_inspect['class_title'] >
	>
	type $bog_vmap_app_inspect__base_bog_vmap_app_162 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_base'] >
		,
		ReturnType< $bog_vmap_app_inspect['base'] >
	>
	type $bog_vmap_app_inspect__bases_bog_vmap_app_163 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_bases'] >
		,
		ReturnType< $bog_vmap_app_inspect['bases'] >
	>
	type $bog_vmap_app_inspect__base_titles_bog_vmap_app_164 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_base_titles'] >
		,
		ReturnType< $bog_vmap_app_inspect['base_titles'] >
	>
	type $bog_vmap_app_inspect__sub_note_bog_vmap_app_165 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_inspect['sub_note'] >
	>
	type $bog_vmap_app_inspect__title_note_bog_vmap_app_166 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_title_note'] >
		,
		ReturnType< $bog_vmap_app_inspect['title_note'] >
	>
	type $bog_vmap_app_inspect__renamable_bog_vmap_app_167 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_renamable'] >
		,
		ReturnType< $bog_vmap_app_inspect['renamable'] >
	>
	type $bog_vmap_app_inspect__cell_bog_vmap_app_168 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_cell'] >
		,
		ReturnType< $bog_vmap_app_inspect['cell'] >
	>
	type $bog_vmap_app_inspect__resettable_bog_vmap_app_169 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_resettable'] >
		,
		ReturnType< $bog_vmap_app_inspect['resettable'] >
	>
	type $bog_vmap_app_inspect__reset_bog_vmap_app_170 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_reset'] >
		,
		ReturnType< $bog_vmap_app_inspect['reset'] >
	>
	type $bog_vmap_app_inspect__share_able_bog_vmap_app_171 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_share_able'] >
		,
		ReturnType< $bog_vmap_app_inspect['share_able'] >
	>
	type $bog_vmap_app_inspect__share_mark_bog_vmap_app_172 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_share_mark'] >
		,
		ReturnType< $bog_vmap_app_inspect['share_mark'] >
	>
	type $bog_vmap_app_inspect__share_bog_vmap_app_173 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_share'] >
		,
		ReturnType< $bog_vmap_app_inspect['share'] >
	>
	type $bog_vmap_app_inspect__share_unshare_bog_vmap_app_174 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_share_unshare'] >
		,
		ReturnType< $bog_vmap_app_inspect['share_unshare'] >
	>
	type $bog_vmap_app_inspect__shares_bog_vmap_app_175 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_shares'] >
		,
		ReturnType< $bog_vmap_app_inspect['shares'] >
	>
	type $bog_vmap_app_inspect__share_uses_bog_vmap_app_176 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_share_uses'] >
		,
		ReturnType< $bog_vmap_app_inspect['share_uses'] >
	>
	type $bog_vmap_app_inspect__share_value_bog_vmap_app_177 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_share_value'] >
		,
		ReturnType< $bog_vmap_app_inspect['share_value'] >
	>
	type $bog_vmap_app_inspect__editable_bog_vmap_app_178 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_editable'] >
		,
		ReturnType< $bog_vmap_app_inspect['editable'] >
	>
	type $mol_page__title_bog_vmap_app_179 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_bog_vmap_app_180 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $bog_vmap_app_code__klass_bog_vmap_app_181 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['code_klass'] >
		,
		ReturnType< $bog_vmap_app_code['klass'] >
	>
	type $bog_vmap_app_code__prop_bog_vmap_app_182 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['code_prop'] >
		,
		ReturnType< $bog_vmap_app_code['prop'] >
	>
	type $bog_vmap_app_code__hooks_bog_vmap_app_183 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['code_hooks'] >
		,
		ReturnType< $bog_vmap_app_code['hooks'] >
	>
	type $bog_vmap_app_code__whole_bog_vmap_app_184 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['code_whole'] >
		,
		ReturnType< $bog_vmap_app_code['whole'] >
	>
	type $bog_vmap_app_code__source_bog_vmap_app_185 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['code_source'] >
		,
		ReturnType< $bog_vmap_app_code['source'] >
	>
	type $bog_vmap_app_code__node_source_bog_vmap_app_186 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_source'] >
		,
		ReturnType< $bog_vmap_app_code['node_source'] >
	>
	type $bog_vmap_app_code__js_bog_vmap_app_187 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['code_js'] >
		,
		ReturnType< $bog_vmap_app_code['js'] >
	>
	type $bog_vmap_app_code__css_bog_vmap_app_188 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['code_css'] >
		,
		ReturnType< $bog_vmap_app_code['css'] >
	>
	type $bog_vmap_app_code__error_bog_vmap_app_189 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['code_error'] >
		,
		ReturnType< $bog_vmap_app_code['error'] >
	>
	type $bog_vmap_app_code__node_note_bog_vmap_app_190 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['code_node_note'] >
		,
		ReturnType< $bog_vmap_app_code['node_note'] >
	>
	type $bog_vmap_app_code__editable_bog_vmap_app_191 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['node_editable'] >
		,
		ReturnType< $bog_vmap_app_code['editable'] >
	>
	type $mol_chip__title_bog_vmap_app_192 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_chip['title'] >
	>
	type $mol_chip__hint_bog_vmap_app_193 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_chip['hint'] >
	>
	type $bog_vmap_app_history__Title_bog_vmap_app_194 = $mol_type_enforce<
		any
		,
		ReturnType< $bog_vmap_app_history['Title'] >
	>
	type $bog_vmap_app_history__store_bog_vmap_app_195 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['store'] >
		,
		ReturnType< $bog_vmap_app_history['store'] >
	>
	type $bog_vmap_app_history__state_bog_vmap_app_196 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['history_state'] >
		,
		ReturnType< $bog_vmap_app_history['state'] >
	>
	type $bog_vmap_lib_land_stack__pack_bog_vmap_app_197 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['pack_link'] >
		,
		ReturnType< $bog_vmap_lib_land_stack['pack'] >
	>
	type $bog_vmap_lib_land_stack__lands_bog_vmap_app_198 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['lands'] >
		,
		ReturnType< $bog_vmap_lib_land_stack['lands'] >
	>
	type $mol_status__status_bog_vmap_app_199 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['status'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_bar__sub_bog_vmap_app_200 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['notes'] >
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_button_minor__title_bog_vmap_app_201 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['zoom_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_202 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_203 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['zoom_full'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_status__status_bog_vmap_app_204 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['error'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_paragraph__title_bog_vmap_app_205 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['inside_note'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_vmap_app_206 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['root_title_note'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_vmap_app_207 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['export_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_bar__sub_bog_vmap_app_208 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['stall_content'] >
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_paragraph__title_bog_vmap_app_209 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['stall_note'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_bog_vmap_app_210 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_211 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_212 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['pack_default'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_vmap_app_213 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_214 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_215 = $mol_type_enforce<
		ReturnType< $bog_vmap_app['scene_restart'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__style_bog_vmap_app_216 = $mol_type_enforce<
		({ 
			'left': ReturnType< $bog_vmap_app['ghost_left'] >,
			'top': ReturnType< $bog_vmap_app['ghost_top'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_vmap_app_217 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_vmap_app extends $mol_page {
		theme_name( ): string
		Theme( ): $mol_theme_auto
		Tooltip( ): $bog_tooltip_plugin
		doc_pending( ): boolean
		main( ): readonly($mol_view)[]
		Main( ): $mol_view
		floats( ): readonly($mol_view)[]
		Left_icon( ): $mol_icon_dock_left
		Left_check( ): $mol_check_icon
		Tool_select_icon( ): $mol_icon_cursor_default_outline
		Tool_select( ): $mol_check_icon
		Tool_board_icon( ): $mol_icon_artboard
		editable( ): boolean
		Tool_board( ): $mol_check_icon
		Tool_text_icon( ): $mol_icon_format_text
		text_enabled( ): boolean
		Tool_text( ): $mol_check_icon
		Tool_hand_icon( ): $mol_icon_hand_back_right_outline
		Tool_hand( ): $mol_check_icon
		delete_hint( ): string
		delete_enabled( ): boolean
		node_delete( next?: any ): any
		Delete( ): $mol_button_minor
		instruments( ): readonly(any)[]
		Instruments( ): $mol_bar
		readonly_badge( ): any
		root_draft( next?: string ): string
		root_submit( next?: any ): any
		Root_name( ): $mol_string
		zoom_out( next?: any ): any
		Zoom_out( ): $mol_button_minor
		camera_reset( next?: any ): any
		Zoom_reset( ): $mol_button_minor
		zoom_in( next?: any ): any
		Zoom_in( ): $mol_button_minor
		History_icon( ): $mol_icon_history
		History_check( ): $mol_check_icon
		doc_readonly( ): boolean
		publish_part( ): string
		node_source( next?: string ): string
		node_js( ): string
		Publish( ): $bog_vmap_app_publish
		export_title( ): string
		export_hint( ): string
		export_ready( ): boolean
		export_blob( ): $mol_blob
		export_file( ): string
		Download( ): $mol_button_download
		Lights( ): $mol_lights_toggle
		Right_icon( ): $mol_icon_dock_right
		Right_check( ): $mol_check_icon
		Left_tabs( ): $mol_switch
		left_panel( ): any
		right_width( ): number
		right_content( ): readonly($mol_view)[]
		grip_press( next?: any ): any
		grip_reset( next?: any ): any
		align_act( id: any, next?: any ): any
		align_enabled( id: any): boolean
		align_note( ): string
		Canvas_body( ): ReturnType< ReturnType< $bog_vmap_app['Canvas'] >['Body'] >
		Canvas_foot( ): ReturnType< ReturnType< $bog_vmap_app['Canvas'] >['Foot'] >
		pack_script( ): string
		scene_theme( ): string
		entered( next?: any ): any
		libs( ): readonly($bog_vmap_bridge_part)[]
		carrying( ): boolean
		doc_wires( ): readonly($bog_vmap_lang_link)[]
		part_ports( id: any): readonly($bog_vmap_app_wire_port)[]
		part_overs( id: any): readonly(string)[]
		link_add( next?: any ): any
		link_drop( next?: any ): any
		doc_containers( ): readonly(string)[]
		doc_names( ): readonly(string)[]
		doc_paths( ): readonly(string)[]
		doc_key( ): string
		doc_axis( id: any): string
		tree_move( next?: any ): any
		carry_drop( next?: any ): any
		files_drop( next?: any ): any
		node_copy( next?: any ): any
		node_wrap( next?: any ): any
		node_group( next?: any ): any
		node_ungroup( next?: any ): any
		ungroup_enabled( ): boolean
		node_reset_all( next?: any ): any
		reset_enabled( ): boolean
		node_clone( next?: any ): any
		board_draw( next?: any ): any
		text_draw( next?: any ): any
		node_resize( next?: any ): any
		node_text( id: any): string
		node_text_kind( id: any): string
		node_text_write( next?: any ): any
		tool_select( next?: ReturnType< ReturnType< $bog_vmap_app['Pane'] >['tool_select'] > ): ReturnType< ReturnType< $bog_vmap_app['Pane'] >['tool_select'] >
		tool_board( next?: ReturnType< ReturnType< $bog_vmap_app['Pane'] >['tool_board'] > ): ReturnType< ReturnType< $bog_vmap_app['Pane'] >['tool_board'] >
		tool_text( next?: ReturnType< ReturnType< $bog_vmap_app['Pane'] >['tool_text'] > ): ReturnType< ReturnType< $bog_vmap_app['Pane'] >['tool_text'] >
		tool_hand( next?: ReturnType< ReturnType< $bog_vmap_app['Pane'] >['tool_hand'] > ): ReturnType< ReturnType< $bog_vmap_app['Pane'] >['tool_hand'] >
		node_show( next?: ReturnType< ReturnType< $bog_vmap_app['Pane'] >['node_show'] > ): ReturnType< ReturnType< $bog_vmap_app['Pane'] >['node_show'] >
		Pane( ): $bog_vmap_app_pane
		canvas_foot( ): readonly($mol_view)[]
		face_brief( ): string
		face_note( ): string
		face_who( ): string
		face_blob( ): $mol_blob
		face_file( ): string
		face_draft( next?: string ): string
		face_take( next?: any ): any
		face_status( ): string
		inner_kids( id: any): readonly(string)[]
		inner_class( id: any): string
		inner_alien( id: any): boolean
		lib_classes( ): readonly($mol_tree2)[]
		lib_class_list( ): readonly(string)[]
		shelf_place( next?: string ): string
		node_peers( ): readonly($mol_tree2)[]
		pack_link( ): string
		node_title( next?: string ): string
		node_base( next?: string ): string
		node_bases( ): readonly(string)[]
		node_base_titles( ): Record<string, any>
		node_title_note( ): string
		node_renamable( ): boolean
		node_cell( id: any, next?: any ): any
		node_resettable( id: any): boolean
		node_reset( id: any, next?: any ): any
		node_share_able( id: any): boolean
		node_share_mark( id: any): string
		node_share( id: any, next?: any ): any
		node_share_unshare( id: any, next?: any ): any
		node_shares( ): readonly(string)[]
		node_share_uses( id: any): string
		node_share_value( id: any, next?: $mol_tree2_empty ): $mol_tree2_empty
		node_editable( ): boolean
		idle_note( ): string
		Idle_note( ): $mol_paragraph
		code_klass( ): string
		code_prop( ): string
		code_hooks( ): readonly(string)[]
		code_error( ): string
		code_node_note( ): string
		lands( ): readonly(string)[]
		status( ): string
		notes( ): readonly($mol_view)[]
		zoom_title( ): string
		zoom_full( next?: any ): any
		error( ): string
		inside_note( ): string
		root_title_note( ): string
		export_text( id: any): string
		stall_content( ): readonly($mol_view)[]
		stall_note( ): string
		pack_default( next?: any ): any
		scene_restart( next?: any ): any
		ghost_left( ): string
		ghost_top( ): string
		ghost_title( ): string
		chrome_click( next?: any ): any
		doc_src( ): string
		doc_css( ): string
		spots( next?: Record<string, any> ): Record<string, any>
		guides( next?: Record<string, any> ): Record<string, any>
		selected( next?: any ): any
		picked( next?: readonly(string)[] ): readonly(string)[]
		inner( next?: string ): string
		doc_js( ): Record<string, any>
		doc_root( ): string
		scene_bundle( ): string
		links( next?: string ): string
		left_showed( next?: boolean ): boolean
		right_showed( next?: boolean ): boolean
		left_tab( next?: string ): string
		right_tab( next?: string ): string
		code_showed( next?: boolean ): boolean
		history_showed( next?: boolean ): boolean
		history_state( next?: Record<string, any> ): Record<string, any>
		code_whole( next?: boolean ): boolean
		code_source( next?: string ): string
		code_js( next?: string ): string
		code_css( next?: string ): string
		root_js( next?: string ): string
		root_css( next?: string ): string
		lights( next?: boolean ): boolean
		store( ): $bog_vmap_app_store
		title( ): string
		plugins( ): readonly(any)[]
		sub( ): readonly(any)[]
		head( ): readonly(any)[]
		tools( ): readonly(any)[]
		Left( ): $mol_view
		Right( ): $mol_view
		Right_grip( ): $mol_view
		right_panel( ): any
		Right_tabs( ): $mol_switch
		Align( ): $bog_vmap_app_align
		Canvas( ): $mol_page
		Scenes( ): $bog_vmap_app_scenes
		Layers( ): $bog_vmap_app_layers
		Shelf( ): $bog_vmap_app_shelf
		Inspect( ): $bog_vmap_app_inspect
		Idle( ): $mol_page
		Code( ): $bog_vmap_app_code
		Readonly( ): $mol_chip
		History( ): $bog_vmap_app_history
		Lib( ): $bog_vmap_lib_land_stack
		Status( ): $mol_status
		Foot_bar( ): $mol_bar
		Zoom_chip( ): $mol_button_minor
		Alarm( ): $mol_status
		Inside_note( ): $mol_paragraph
		Root_note( ): $mol_paragraph
		Export_row( id: any): $mol_paragraph
		pack_stalled( ): boolean
		Stall( ): $mol_bar
		Stall_note( ): $mol_paragraph
		Stall_pack( ): $mol_button_minor
		Stall_reload( ): $mol_button_minor
		Ghost( ): $mol_view
		event( ): ({ 
			click( next?: ReturnType< $bog_vmap_app['chrome_click'] > ): ReturnType< $bog_vmap_app['chrome_click'] >,
		})  & ReturnType< $mol_page['event'] >
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map